// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"745ec019","154":"4c4411c5","163":"1c44bfa6","234":"cefa1f42","277":"7e93552e","381":"a73cd21b","572":"4f74a102","605":"c92e34da","768":"5b28b031","848":"6e309a76","910":"15f9c640","978":"4187a8a4"}[chunkId] + ".chunk.js";
};